export const defaultUserObj = {
  user_id: 'not logged in',
} as const

export const adcContextPrefix = 'tenx.adc' as const

export const analyticTools = {
  gtm: 'gtm',
  ga: 'ga',
} as const

export type AnalyticTool = (typeof analyticTools)[keyof typeof analyticTools]
